module.exports = __webpack_public_path__ + "img/네크로맨서.942b86bf.png";